import { motion, AnimatePresence } from 'framer-motion';

interface LoadingIndicatorProps {
  isVisible: boolean;
}

export default function LoadingIndicator({ isVisible }: LoadingIndicatorProps) {
  return (
    <AnimatePresence>
      {isVisible && (
        <>
          {/* 상단 진행 막대 */}
          <motion.div
            className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 z-50"
            initial={{ width: "0%" }}
            animate={{
              width: "100%",
              transition: { duration: 1.5, ease: "easeInOut" }
            }}
            exit={{
              width: "100%",
              opacity: 0,
              transition: { duration: 0.3 }
            }}
          />
          
          {/* 작은 상태 표시기 (선택사항) */}
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 500, damping: 30 }}
            className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-white/80 shadow-lg rounded-full px-4 py-1.5 backdrop-blur-sm pointer-events-none"
          >
            <div className="flex items-center gap-2">
              <div className="flex items-center space-x-0.5">
                {[0, 1, 2].map(i => (
                  <motion.div
                    key={i}
                    className="w-1.5 h-1.5 rounded-full bg-indigo-600"
                    initial={{ opacity: 0.3 }}
                    animate={{ opacity: [0.3, 1, 0.3] }}
                    transition={{
                      duration: 1,
                      repeat: Infinity, 
                      delay: i * 0.15,
                      ease: "easeInOut"
                    }}
                  />
                ))}
              </div>
              <span className="text-xs font-medium text-gray-700">이동 중</span>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
} 